import React from 'react';
import { Button, LoadingErrors } from '@shared/ui';
import { language, TErrorLoadingDataProps } from '../model';
import { cn } from '@shared/lib';
import { Danger } from 'iconsax-react';

export const ErrorLoadingData = ({
  text,
  buttonText,
  inline,
  refetch,
  className,
  id,
  'data-testid': dataTestId,
}: TErrorLoadingDataProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        inline ? 'flex-row w-full' : 'flex-col',
        className
      )}
      id={id}
      data-testid={dataTestId}
    >
      {inline ? (
        <Danger variant='Linear' size={18} className='text-red-1 ml-1 [&_path]:[stroke-width:2]' />
      ) : (
        <LoadingErrors className='text-pics opacity-40' />
      )}
      <div className={`leading-[21px] font-bold text-xs  ${inline ? 'text-red-1' : 'pt-[24px]'}`}>
        {text || language.defaultLoadingDataErrorMessage}
      </div>
      {refetch && (
        <Button isDanger variant='outline' onClick={refetch} className={`rounded-lg font-normal ${inline ? 'mr-2' : 'mt-2'}`}>
          {buttonText || language.defaultUpdateButtonText}
        </Button>
      )}
    </div>
  );
};
